import Phaser from 'phaser'

import Preload from './scenes/Preload';
import Game from './scenes/Game';
import GameOver from './scenes/GameOver';
import MainMenu from './scenes/MainMenu';
import PauseMenu from './scenes/PauseMenu';
import GameGuide from './scenes/GameGuide';

const config = {
    type: Phaser.CANVAS,
    parent: 'phaser-example',
    scale: {
        mode: Phaser.Scale.FIT,
    },
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 800,
    height: 1600,

    physics: {
        default: 'arcade',
        arcade: {
            debug: false
        }
    },
    scene: [Preload, MainMenu, GameGuide, Game, PauseMenu, GameOver]
};

export default new Phaser.Game(config);